document.addEventListener("DOMContentLoaded", () => {
  function RelatedSwiper() {
    new Swiper(".related-products-list", {
      slidesPerView: 5,
      spaceBetween: 25,
      pagination: {
        el: ".related-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".related-btn-next",
        prevEl: ".related-btn-prev",
      },
      breakpoints: {
        1300: { slidesPerView: 5, spaceBetween: 25 },
        1000: { slidesPerView: 4, spaceBetween: 15 },
        769: { slidesPerView: 3, spaceBetween: 15 },
        500: { slidesPerView: 2, spaceBetween: 15 },
        300: { slidesPerView: 1.2, spaceBetween: 8 },
      },
    });
  }

  const checkInterval = setInterval(() => {
    const relatedContainer = document.querySelector(".related-products-list");
    if (relatedContainer && !relatedContainer.classList.contains("swiper-initialized")) {
      RelatedSwiper();
      clearInterval(checkInterval);
    }
  }, 1000);

});
